import React, { Component, Fragment } from 'react';
import { textContainer } from '../../styles';
import Animated from '../Animated';
import BigList from '../BigList';

const getBlomHeader = (index) => {
  return [
    {
      srcSet: require(`../../assets/blom/blom-a-generative-art-series-by-lucastswick-thumb-${index}.jpg`),
      media: '(max-width: 100px)',
    },
    {
      srcSet: require(`../../assets/blom/blom-a-generative-art-series-by-lucastswick-sm-${index}.jpg`),
      media: '(max-width: 720px)',
    },
    {
      srcSet: require(`../../assets/blom/blom-a-generative-art-series-by-lucastswick-${index}.jpg`),
    },
  ];
};

class WorkList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    this.props.loadTheme();
    this.props.loadWork();
  }
  componentWillReceiveProps(nextProps) {
    const { work, theme } = nextProps;
    if (work && work.length && theme && theme.blomIndex) {
      work[0].headerImage = getBlomHeader(theme.blomIndex);
    }
  }
  render() {
    const { work, theme } = this.props;
    return (
      <Fragment>
        <div {...textContainer}>
          <Animated as="h1">Case Studies</Animated>
        </div>
        <BigList items={work} theme={theme} />
      </Fragment>
    );
  }
}

export default WorkList;



// WEBPACK FOOTER //
// ./src/components/WorkList/WorkList.js